(function () {
  'use strict';

  var configElement = document.getElementById('ConsentTracking');

  if (!configElement) {
    return;
  }

  var gtmContainerId = configElement.dataset.gtmContainerId;
  var onsiteAccountId = configElement.dataset.onsiteAccountId;
  var gtmLoaded = false;
  var onsiteLoaded = false;
  var previousConsentState = null;
  var privacyApiRequested = false;
  var privacyApiAttempts = 0;
  var maxPrivacyApiAttempts = 40;
  var acceptAllRequested = false;
  var acceptAllPersisting = false;

  function getConsentState() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy) {
      return null;
    }

    try {
      return {
        analytics: customerPrivacy.analyticsProcessingAllowed() === true,
        marketing: customerPrivacy.marketingAllowed() === true,
        preferences: customerPrivacy.preferencesProcessingAllowed() === true,
      };
    } catch (error) {
      console.warn('Tracking consent could not be read.', error);
      return null;
    }
  }

  function getConsentStateFromEvent(event) {
    var eventConsent = event && event.detail;

    if (
      !eventConsent ||
      typeof eventConsent.analyticsAllowed !== 'boolean' ||
      typeof eventConsent.marketingAllowed !== 'boolean'
    ) {
      return null;
    }

    return {
      analytics: eventConsent.analyticsAllowed,
      marketing: eventConsent.marketingAllowed,
      preferences: eventConsent.preferencesAllowed === true,
    };
  }

  function updateGoogleConsent(consentState, command) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('consent', command, {
      analytics_storage: consentState.analytics ? 'granted' : 'denied',
      ad_storage: consentState.marketing ? 'granted' : 'denied',
      ad_user_data: consentState.marketing ? 'granted' : 'denied',
      ad_personalization: consentState.marketing ? 'granted' : 'denied',
      functionality_storage: consentState.preferences ? 'granted' : 'denied',
      personalization_storage: consentState.preferences ? 'granted' : 'denied',
      security_storage: 'granted',
    });
  }

  function loadGoogleTagManager() {
    if (gtmLoaded || !/^GTM-[A-Z0-9]+$/.test(gtmContainerId || '')) {
      return;
    }

    gtmLoaded = true;

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    var gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.id = 'GoogleTagManagerScript';
    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(gtmContainerId);
    document.head.appendChild(gtmScript);
  }

  function loadOnsiteTracking() {
    if (onsiteLoaded || !onsiteAccountId) {
      return;
    }

    onsiteLoaded = true;
    window.OnSiteObject = 'onsite';
    window.onsite = window.onsite || function () {
      (window.onsite.q = window.onsite.q || []).push(arguments);
    };

    var onsiteScript = document.createElement('script');
    onsiteScript.async = true;
    onsiteScript.id = 'OnsiteTrackingScript';
    onsiteScript.src = 'https://trk.herofil.es/onsite/onsite.js';
    document.head.appendChild(onsiteScript);

    window.onsite('create', onsiteAccountId);
  }

  function applyConsentState(consentState) {
    // HeroFiles doesn't expose a documented command for stopping an active
    // OnSite session. Reload after a marketing-consent withdrawal so the
    // third-party script is removed from the browser context immediately.
    var marketingConsentWithdrawn =
      onsiteLoaded &&
      previousConsentState &&
      previousConsentState.marketing &&
      !consentState.marketing;

    previousConsentState = consentState;
    updateGoogleConsent(consentState, 'update');

    if (marketingConsentWithdrawn) {
      window.location.reload();
      return;
    }

    if (consentState.analytics || consentState.marketing) {
      loadGoogleTagManager();
    }

    if (consentState.marketing) {
      loadOnsiteTracking();
    }
  }

  function applyConsent(event) {
    // During visitorConsentCollected, event.detail is the authoritative new
    // state. Reading the API again here can still return the previous value.
    var consentState = getConsentStateFromEvent(event) || getConsentState();

    if (!consentState) {
      return;
    }

    applyConsentState(consentState);
  }

  function persistAcceptAllConsent() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
      acceptAllRequested = true;
      initializeCustomerPrivacy();
      return;
    }

    if (acceptAllPersisting) {
      return;
    }

    acceptAllRequested = false;
    acceptAllPersisting = true;

    // This runs only after an explicit click on Shopify's "Accept all" button.
    // It keeps Shopify's stored consent and Google Consent Mode in sync if the
    // native banner publishes analytics consent without the marketing signal.
    customerPrivacy.setTrackingConsent(
      {
        analytics: true,
        marketing: true,
        preferences: true,
      },
      function () {
        acceptAllPersisting = false;
        applyConsentState({
          analytics: true,
          marketing: true,
          preferences: true,
        });
      }
    );
  }

  function handleCookieBannerClick(event) {
    var target = event && event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    if (!target.closest('#shopify-pc__banner__btn-accept')) {
      return;
    }

    acceptAllRequested = true;

    // Wait until Shopify's own click handler has completed, then persist the
    // full "Accept all" decision through the official Customer Privacy API.
    window.setTimeout(persistAcceptAllConsent, 0);
  }

  function initializeCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      if (acceptAllRequested) {
        persistAcceptAllConsent();
      } else {
        applyConsent();
      }
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      if (privacyApiRequested) {
        return;
      }

      privacyApiRequested = true;
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        function (error) {
          if (error) {
            console.warn('Shopify Customer Privacy API could not be loaded.', error);
            return;
          }

          if (acceptAllRequested) {
            persistAcceptAllConsent();
          } else {
            applyConsent();
          }
        }
      );
      return;
    }

    privacyApiAttempts += 1;

    if (privacyApiAttempts < maxPrivacyApiAttempts) {
      window.setTimeout(initializeCustomerPrivacy, 250);
    }
  }

  document.addEventListener('visitorConsentCollected', applyConsent);
  document.addEventListener('click', handleCookieBannerClick, true);
  initializeCustomerPrivacy();
})();
